







































import store from '../../../store'
import * as utils from '@ivy/fts/utils'
import * as weixin from '@ivy/fts/weixin'
import ConvertPinyin from '../../../ConvertPinyin'
import * as toImage from '../../../toImage'
import qs from 'qs'
import ResultCard from './resultCard.vue'
import IvyContent from './ivyContent.vue'
import IButton from './iButton.vue'
import axios from 'axios'

import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
@Component({
  components: { ResultCard, IvyContent, IButton },
})
export default class ResultCardContent extends Vue {
  store: any = store
  tipsText: string = '长按保存图片'
  result: any = {}
  ok: boolean = false
  weChatAvatar: any = ''
  faceImage: string = ''
  animated: boolean = false
  shareDiv: boolean = false
  hiddenText: boolean = false
  async mounted() {
    await store.login(this)
    await this.getResult()
    await this.setShare()
  }
  async getResult() {
    let {
      name: full_name,
      sex,
      birday,
      openid,
      shared,
      name_id,
    } = this.$route.query
    if (!full_name || !sex || !birday || !openid) return this.againTest()
    let { data } = await axios.post(
      `/api/mobile/h5/nameEnglish/getEnglishName`,
      {
        full_name,
        sex: sex || 'M',
        birday,
        name_id,
        openid,
      }
    )
    this.result = data
    this.ok = true
    // this.weChatAvatar = await toImage.img2base64(await this.ossImg(data.user.headimgurl))
    this.faceImage = `${ConvertPinyin(data.imgName)}.png`
    this.renderImage()
  }
  async ossImg(url) {
    let avatarUrl = url
    if (avatarUrl && avatarUrl.includes('https://wx.qlogo.cn/mmopen')) {
      avatarUrl = avatarUrl.replace(
        'https://wx.qlogo.cn/mmopen',
        'https://service.ivydad.com/old_wechat_image'
      )
    } else if (
      avatarUrl &&
      avatarUrl.includes('http://thirdwx.qlogo.cn/mmopen')
    ) {
      avatarUrl = avatarUrl.replace(
        'http://thirdwx.qlogo.cn/mmopen',
        'https://service.ivydad.com/wechat_image'
      )
    } else {
      return avatarUrl
    }
    return avatarUrl
  }
  async renderImage() {
    await utils.sleep(2000)
    this.hiddenText = true
    await utils.sleep(100)
    await this.saveImage()
    this.hideCardShowImage()
  }
  async saveImage() {
    await this.$nextTick()
    let cardClassName = `.name-result-card-container`
    let imageBox = `.image-container`
    if (document.querySelector(cardClassName)) {
      if (!+this.$route.query.shared) {
        this.tipsText = ''
        let tips = document.querySelector('.share-tips-text') as any
        tips.style.height = `0px`
      }
      let r = await toImage.drawCanvas(cardClassName)
      let baseImage = r.toDataURL('image/png')
      let img = document.createElement('img')
      img.src = baseImage
      img.style.width = '100%'
      document.querySelector(imageBox) &&
        document.querySelector(imageBox).appendChild(img)
    }
  }
  hideCardShowImage() {
    let body = document.querySelector('.name-result-container') as any
    if (!+this.$route.query.shared && body) {
      body.style.backgroundColor = `rgba(0, 0, 0, .3)`
      body.style.backgroundImage = `none`
    }
    let card = document.querySelector('.name-result-card-container') as any
    let image = document.querySelector('.image-container') as any
    if (!+this.$route.query.shared) {
      card && (card.className += ` animated fadeOut`)
      image && (image.className += ` animated zoomin`)
    }
    card.style.display = 'none'
    this.animated = !+this.$route.query.shared
  }
  againTest() {
    return this.$router.push('/h5nameChild')
  }
  async setShare() {
    let { name, sex, birday, openid } = this.$route.query
    let { name_id } = this.result
    await weixin.weixinShare({
      title: '我给宝宝起了个新英文名字，来看看！',
      desc: '英文名字hin实用，测试有点准~关注服务号还能领免费英语启蒙课程！',
      imgUrl:
        'https://service.ivydad.com/tools/imagePage8de40bfc-8862-32df-6766-41aad9d68be5.jpg',
      link: `${window.location.origin}/h5/h5nameResult?${qs.stringify({
        name,
        sex,
        birday,
        openid,
        name_id,
        shared: 1,
      })}`,
    })
  }
}
